import React from "react";
import FilterItem from "../../assets/components/FilterItem";

const EventFilters = ({ handleClick, selected }) => {
  return (
    <div className="w-100 mt-1 mb-4 d-flex">
      <FilterItem
        title={"همه"}
        handleClick={() => handleClick("")}
        selected={selected === ""}
      />
      <FilterItem
        title={"آرشیو"}
        handleClick={() => handleClick("Archived")}
        selected={selected === "Archived"}
      />
      {/* <FilterItem
        title={"رزرو شده"}
        handleClick={() => handleClick("reserved")}
        selected={selected === "reserved"}
      /> */}
    </div>
  );
};

export default EventFilters;
